var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading text-center my-4"},[_c('div',{staticClass:"jumbotron"},[_c('div',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-spinner fa-pulse fa-3x text-primary"}),_c('p',{staticClass:"lead mt-3"},[_vm._v("Cargando...")])])])])
}]

export { render, staticRenderFns }